import { Card } from "@mui/material";

const enums = {
  ApiResult: {
    Ok: 200,
    Unauthorized: 201,
    BadRequest: 400,
    AccessDenied: 401,
    NotFound: 404,
    Timeout: 408,
    ValidationError: 422,
    InternalServerError: 500,
    InsufficientStorage: 507
  },

  UserStatus: {
    NewUser: 0,
    Active: 1,
    Deactive: 2
  },

  UserStatusName: {
    0: 'New User',
    1: 'Active',
    2: 'Deactive'
  },

  Duration: {
    Today: 0,
    Yesterday: 1,
    CurrentWeek: 2,
    Last7Days: 3,
    CurrentMonth: 4,
    LastMonth: 5,
    ThreeMonths: 6,
    SixMonths: 7,
    CurrentYear: 8,
    LastYear: 9,
    Between: 10
  },

  SortBy: {
    DESC: 2,
    ASC: 1
  },

  userRole: {
    SuperAdmin: 1,
    CJAdmin: 2,
    User: 3,
    SiteManager: 4,
    EdmExport: 6
  },

  OrderModes: ['WalkIn', 'EatIn', 'DriveThru', 'Delivery', 'DeliveryNI'],

  PaymentModes: ['Card', 'Cash', 'Pinpad', 'Integrated', 'Virtual', 'Adyen'],

  MealSize: ['0', '1', '2'],

  deviceType: ['Kiosk', 'Mobile', 'Pos'],

  BannerType: {
    1: 'Section 1',
    2: 'Section 2',
    3: 'Section 3',
    4: 'Section 4',
    11: 'Kiosk'
  },

  ComboSize: {
    0: 'Small',
    1: 'Medium',
    2: 'Large',
    3: 'XLarge',
    4: 'Giant',
  },

  ModifiersSet: {
    2: 'Protien',
    3: 'Cheese',
    4: 'Sauce',
    5: 'Packet Sauce',
    6: 'Salad',
    7: 'Bun',
    8: 'Choice of Sauces',
    9: 'Spice Level'
  },

  DeliveryType: {
    2: 'Uber',
    3: 'Doordash'
  },

  OrderStatus: ['PROCESSING', 'PAID', 'PAYMENT FAILED', 'PLACED', 'COOKING', 'FULFILLED', 'CANCELED', 'REFUNDED'],

  SummaryType: {
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly'
  },

  OrderSource: ['Kiosk', 'Mobile', 'POS'],

  supportedDevices: {
    Kiosk: 'Kiosk',
    App: 'App',
    POS: 'Pos',
    KDS: 'Kds'
  },

  AdminRole: {
    1: 'Super Admin',
    2: 'Brand CMS Admin',
    3: 'User',
    4: 'Site Manager',
    5: 'POS Employee',
    6: 'Edm Export'
  },

  ComparisonType: {
    '<': '<',
    '<=': '<=',
    '>': '>',
    '>=': '>=',
    '=': '='
  },

  Gender: {
    Male: 'M',
    Female: 'F',
    Others: 'O',
    'Un Specified': 'U'
  },

  PosScreenType: {
    singleDisplay: 1,
    doubleDisplayClient: 2,
    doubleDisplayServer: 3
  },

  KioskNotificationType: {
    ScreenSaver: 'Screen Saver',
    MenuScreen: 'MenuScreen'
  },

  orderSource: {
    kiosk: 'Kiosk',
    pos: 'POS',
    mobile: 'Mobile'
  },
  DisablePosItemType: {
    MenuItemType: 1,
    ModifierItemType: 2,
    ComboType: 3
  },
  SyncButtons: ['Screen Savers', 'Menu Items'],
  screenType: {
    prep: 'Prep',
    pack: 'Pack',
    printer: 'Printer',
  },
  groupType: {
    suggestive: 30,
    category: 20,
    subgroup: 25
  },
  menuType: {
    quickCombo: "QuickCombo",
    menuItem: 'MenuItem'
  },
  QuickComboSize: {
    Small: 0,
    Medium: 1,
    Large: 2
  },
  displayAdminRole: {
    superAdmin: 'Super Admin',
    brandCMSAdmin: 'CJ Admin',
    User: 'User',
    siteManager: 'Site Manager',
    posEmployee: 'POS Employee',
  },
  ComboSize: {
    0: 'Small',
    1: 'Medium',
    2: 'Large',
    3: 'Extra Large',
    4: 'Giant'
  },
  bannerVisibility: {
    0: 'All',
    1: 'Member',
    2: 'Guest'
  },
  navigationType: {
    menuItem: 0,
    category: 1,
    displayOnly: 2,
    signUp: 3,
  },
  GroupType: {
    20: 'Category',
    30: 'Suggestive Group',
    25: 'Sub Group',
  },
  flavour: {
    KFC: 1,
    CJSalesUAT: 2,
    CJSalesProd: 3,
    WIngstop: 4,
    OliveTreeProd: 5,
    OliveTreeUAT: 6,
    KountaUAT: 7
  },
  MenuPricingType: {
    MenuItem: 'MenuItem',
    Combo: 'QuickCombo'
  },
  NotificationDisplayType: {
    daily: 'Daily Reminder',
    birthday: 'Birthday Reminder',
    now: 'Now',
    schedule: 'Schedule'
  },
  NotificationType: {
    daily: 'daily',
    now: 'now',
    schedule: 'schedule',
    birthdayReminder: 'birthday'
  },
  RuleType: {
    purchase: 1,
    signup: 2,
    notification: 3,
    birthday: 4,
    sms: 5
  },
  RuleTypeOption: {
    1: 'Purchase',
    2: 'Signup',
    3: 'Notification',
  },
  ExecuteRuleType: {
    input: 'input',
    database: 'database'
  },
  PayType: {
    Stars: 'Stars',
    Card: 'Card',
  }
};

export default enums;
